//账单

export default [

    {   //账单管理
        path: "bill/billmanage",
        name: "billsManage",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/billmanage/index"),
    },
    {   //账单详情
        path: "bill/billmanage/detail",
        name: "billsManageDetail",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/billmanage/detail/index"),
    },
    {   //账单详情详明细
        path: "bill/billmanage/detail/list",
        name: "billsManageDetails",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/billmanage/detail/list"),
    },

    // 客户账单管理
    {
        path: "bill/customer",
        name: "billCustomer",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/customer/index"),
    },
    //客户账单详情
    {
        path: "bill/customer/detail",
        name: "billCustomerDetial",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/billmanage/detail/index"),
    },
    //客户账单详情详明细
    {
        path: "bill/customer/detail/list",
        name: "billCustomerDetials",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/billmanage/detail/list"),
    },
    // 调账
    {
        path: "bill/adjument/list",
        name: "billAdjumentList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/adjument/index"),
    },
    // 交易明细
    {
        path: "bill/transaction/list",
        name: "transactionList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/transaction/index"),
    },
    {   //交易异常记录
        path: "bill/abnormal",
        name: "billAbnormal",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/abnormal/index"),
    },


    // 冻结记录、客户账户管理、异常单据处理、配送费账单/管理
    {
        path: "bill/freeze",
        name: "billCustomerDetials",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/freeze"),
    },
    {
        path: "bill/abnormalorder",
        name: "billCustomerDetials",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/abnormalorder/abnormalorder"),
    },
    {
        path: "bill/accountmanage",
        name: "billCustomerDetials",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/accountmanage"),
    },
    {
        path: "bill/shippingcus",
        name: "billShippingcus",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/shippingfee/cus/index"),
    },
    {
        path: "bill/shippingmanage",
        name: "billShippingManage",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/bill/shippingfee/manage/index"),
    },
]


